import { arrayOf, bool, elementType, func, number } from 'prop-types';
import React from 'react';

import { commentShape } from '../../prop-types';
import CommentEditor from '../CommentEditor.container';

function Replies({
  withReplyForm,
  replies,
  preferableMentions,
  parentId,
  onReply,

  Component,
}) {
  return (
    <div className="mt-2 c-comment__replies">
      {replies.map(comment => (
        <Component key={comment.id} model={comment} />
      ))}
      {withReplyForm && (
        <CommentEditor
          default={{ parentId, text: '', mentions: [] }}
          onClick={onReply}
          preferableMentions={preferableMentions}
        />
      )}
    </div>
  );
}

Replies.propTypes = {
  withReplyForm: bool.isRequired,
  replies: arrayOf(commentShape.isRequired).isRequired,
  preferableMentions: arrayOf(number),
  parentId: number.isRequired,
  onReply: func.isRequired,

  Component: elementType.isRequired,
};

Replies.defaultProps = {
  preferableMentions: [],
};

export default Replies;
